export default __webpack_public_path__ + "static/media/page404.050e22a0.png";